export default [
  {
    title: 'Home',
    icon: 'HomeIcon',
    tagVariant: 'light-warning',
    route: 'home'
  },
]
